const STATIC_SUBSCRIPTION_PLAN_GROUP = [
  {
    id: 10169385254,
    name: "1 Month",
    discount: 15,
  },
  {
    id: 10169352486,
    name: "2 Months",
    discount: 12,
  },
  {
    id: 10169319718,
    name: "3 Months",
    discount: 10,
  },
];

(() => {
  function drawQuickCheckoutItem(input, itemTotalPrice) {
    const isSubscription =
      input.dataset.planId && input.dataset.planId !== "null";

    const subscriptionWidget = `
      <div class="cart-item__subscription ${isSubscription && "selected"}">
        <div class="cart-item__subscription-info-container">
          <label class="cart-selling-option-container">
            <input
              type="checkbox"
              data-item-id="${input.dataset.id}"
              ${isSubscription && "checked"}
            >
            <span class="checkmark"></span>
          </label>

          <div class="cart-item__subscription-info">
            <label>
              Subscribe
              <span>
                You save <span id="quick-checkout-subscription-${
                  input.dataset.id
                }-discount">${
      isSubscription
        ? STATIC_SUBSCRIPTION_PLAN_GROUP.find(
            (plan) => plan.id === Number(input.dataset.planId)
          ).discount
        : STATIC_SUBSCRIPTION_PLAN_GROUP[0].discount
    }</span>%
              </span>
            </label>

            <p>Cancel or delay your deliveries anytime. We'll send an email 1 day before we ship!</p>
          </div>
        </div>

        <div class="cart-item__subscription-period-container">
          <p class="text-size-small text-weight-medium">Ships every</p>

          <div class="cart-item__subscription-period-select" data-item-id="${
            input.dataset.id
          }">
            ${STATIC_SUBSCRIPTION_PLAN_GROUP.map(
              (plan) => `
              <button
                type="button"
                class="cart-item__subscription-period-item ${
                  plan.id === Number(input.dataset.planId) && "active"
                }"
                data-item-id="${input.dataset.id}"
                data-plan-id="${plan.id}"
                data-discount="${plan.discount}"
              >
                ${plan.name}
              </button>
            `
            )
              .join("")
              .toString()}
          </div>
        </div>
      </div>
    `;

    return `
      <div class="quick-checkout__order-wrapper">
        <div class="quick-checkout__order-item">
          <div class="quick-checkout__order-info-container">
          ${
            input.dataset.imageUrl &&
            `
            <div class="quick-checkout__img-container">
              <span class="p-cnt">${input.value}</span>
              <img src="${input.dataset.imageUrl}" loading="lazy" alt="item_preview" class="quick-checkout__order-image" />
            </div>
          `
          }

            <div class="quick-checkout__order-content">
              ${
                input.dataset.title
                  ? `
                <div class="text-weight-semibold text-size-small">${input.dataset.title}</div>
              `
                  : ""
              }

              ${
                input.dataset.colorCategory
                  ? `
                <div class="text-size-small">Color Category:&nbsp;${input.dataset.colorCategory}</div>
              `
                  : ""
              }

              ${
                input.dataset.color
                  ? `
                <div class="text-size-small">Color:&nbsp;${input.dataset.color}</div>
              `
                  : ""
              }

              ${
                input.dataset.size
                  ? `
                <div class="text-size-small">Length:&nbsp;${input.dataset.size}</div>
              `
                  : ""
              }

              ${
                input.dataset.inventory <= 0
                  ? `
                <div class="text-size-small oos-item-note">ON BACK-ORDER</div>
              `
                  : ""
              }

              <div class="button-group">
                <a href="#" class="button-basic w-button js-remove-quick-product" data-target="${
                  input.dataset.id
                }">
                  Remove
                </a>
              </div>
            </div>
          </div>

          <div class="quick-checkout__qty-wrapper">
            <div class="quick-checkout__price">
              <div class="text-size-small-2" id="quick-checkout-price-${
                input.dataset.id
              }">
                ${formatMoney(itemTotalPrice, window.Shopify.money_format)}
              </div>
              
              ${
                input.dataset.compareAtPrice > 0
                  ? `<div class="text-size-small-2 variant--compare_price" id="quick-checkout-origin-price-${
                      input.dataset.id
                    }">
                ${formatMoney(
                  input.dataset.compareAtPrice,
                  window.Shopify.money_format
                )}
              </div>`
                  : ``
              }
            </div>
          </div>
        </div>

        ${input.dataset.isSubscription === "true" ? subscriptionWidget : ""}
      </div>
    `;
  }

  function getOriginTotalPrice(input) {
    return parseInt(input.value) * parseInt(input.dataset.price);
  }

  function getDiscountedTotalPrice(input) {
    const originPrice = getOriginTotalPrice(input);

    const planId = Number(input.dataset.planId);
    const discountValue = STATIC_SUBSCRIPTION_PLAN_GROUP.find(
      (plan) => plan.id === planId
    ).discount;

    return originPrice - originPrice * (discountValue / 100);
  }

  $(document).ready(() => {
    // Add selected products to cart on PDP
    async function addToCart() {
      try {
        const productTitle = document.querySelector(".js-prouct-accordion-wrap")
          .dataset.productName;
        const quantityInputs = document
          .querySelector(".js-prouct-accordion-wrap")
          .querySelectorAll(".variant-qty-input");
        const subscriptionOption = document.querySelector(
          "#recharge-selling-option-2"
        );
        const subscriptionPeriodSelector = document.querySelector(
          ".recharge-period-container select"
        );
        const preOrderInput = document.querySelector("#pre-order-selling-plan");

        let data = [];

        for (let input of quantityInputs) {
          if (input.value > 0) {
            let item = {
              id: input.dataset.id,
              quantity: input.value,
            };

            // Add selling plan if selected subscription
            if (subscriptionOption) {
              item.selling_plan = subscriptionOption.checked
                ? subscriptionPeriodSelector.value
                : null;
            } else if (preOrderInput.dataset.preorderId) {
              item.selling_plan = preOrderInput.dataset.preorderId;
            }

            data.push(item);
          }
        }

        if (data.length === 0) {
          console.log("No items to add to the cart.");
          return;
        }

        // Add items to the cart
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items: data }),
        });

        if (!response.ok) {
          throw new Error("Failed to add items to the cart.");
        }

        console.log("Items added to the cart successfully.");

        // Update UI after successful addition
        document.querySelector(".added-notification_product-title").innerHTML =
          productTitle;
        document.querySelector(".added-notification").classList.add("active");
        document
          .querySelector(".btn-add-to-cart")
          .classList.remove("btn--loading");

        const rechargeForm = document.querySelector(".product-recharge-form");
        if (rechargeForm) {
          rechargeForm.classList.remove("active");
        }

        quantityInputs.forEach((input) => {
          if (input.value > 0) {
            input.value = 0;
          }
        });

        checkVariants();

        document.querySelector(".total-product-num").textContent = 0;
        document.querySelector(".total-price").textContent = formatMoney(
          0,
          window.Shopify.money_format
        );

        setTimeout(() => {
          document
            .querySelector(".added-notification")
            .classList.remove("active");
        }, 6000);

        // Fetch updated cart data
        const cartResponse = await fetch(
          `${window.Shopify.routes.root}cart.js`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!cartResponse.ok) {
          throw new Error("Failed to fetch cart data.");
        }

        const cartData = await cartResponse.json();
        document.querySelector(".header-cart_item-count").textContent =
          cartData.item_count;
      } catch (error) {
        console.error("Error in addToCart:", error);
        document
          .querySelector(".btn-add-to-cart")
          .classList.remove("btn--loading");
      }
    }

    $(".pdp-main-products_question").on("click", function () {
      if (!$(this).hasClass("active")) {
        $(".pdp-main-products_question.active").next().slideToggle();
        $(".pdp-main-products_question.active").toggleClass("active");
      }
      $(this).toggleClass("active");
      $(this).next().slideToggle();
    });

    // Update a total product price based on quantity input on PDP and Quick Checkout
    function updatePDPTotalPrice() {
      if (document.querySelector("h1").textContent === "Quick Checkout") return;

      let totalCount = 0;
      let totalPrice = 0;

      const quantityInputs = document.querySelectorAll(".variant-qty-input");
      const subscriptionOption = document.querySelector(
        "#recharge-selling-option-2"
      );

      quantityInputs.forEach((input) => {
        if (input.value > 0) {
          totalCount += parseInt(input.value);
          totalPrice +=
            parseInt(input.value) *
            parseInt(
              input.dataset.compareAtPrice
                ? input.dataset.compareAtPrice
                : input.dataset.price
            );
        }
      });

      if (document.querySelector(".total-product-num")) {
        document.querySelector(".total-product-num").textContent = totalCount;
      }

      const formattedTotalPrice = formatMoney(
        totalPrice,
        window.Shopify.money_format
      );

      // If the product is available for subscription
      if (subscriptionOption) {
        const rechargeForm = document.querySelector(".product-recharge-form");
        const discountValue = Number(
          document.querySelector("#recharge-discount-value").textContent
        );

        // Display recharge form only when the total quantity is greater than 0
        if (totalCount === 0) {
          rechargeForm.classList.remove("active");
        } else {
          rechargeForm.classList.add("active");
        }

        // Calculate the discounted total price
        const discountTotalPrice = formatMoney(
          totalPrice - totalPrice * (discountValue / 100),
          window.Shopify.money_format
        );

        document.querySelector(".total-price").textContent =
          subscriptionOption.checked ? discountTotalPrice : formattedTotalPrice;
        document.querySelector("#recharge-one-time-price").textContent =
          document.querySelector("#recharge-original-price").textContent =
            formattedTotalPrice;
        document.querySelector("#recharge-discount-price").textContent =
          discountTotalPrice;
      } else {
        document.querySelector(".total-price").textContent =
          formattedTotalPrice;
      }
    }

    function checkVariants() {
      $(".variant-qty-input").each(function () {
        const qty = parseInt($(this).val());
        const variant = $(this).closest(".variant-accordion-item");

        if (qty === 0) {
          variant.addClass("disabled");
        } else {
          variant.removeClass("disabled");
        }
      });
    }

    checkVariants();

    // Handle quantity input click
    $(".btn-qty").on("click", function () {
      let varaintAccordion = this.closest(".variant-accordion");
      let variant = this.closest(".variant-accordion-item");
      let totalCount = 0;
      let totalPrice = 0;

      if (parent && variant) {
        let qty = parseInt(variant.querySelector(".variant-qty-input").value);
        if ($(this).hasClass("qty-plus")) {
          qty++;
        }

        if ($(this).hasClass("qty-minus") && qty > 0) {
          qty--;
        }

        variant.querySelector(".variant-qty-input").value = qty;

        if (qty === 0) {
          variant.classList.add("disabled");
        } else {
          variant.classList.remove("disabled");
        }

        varaintAccordion.querySelectorAll(".variant-qty-input").forEach((e) => {
          const quantity = parseInt(e.value);
          const price = quantity * e.dataset.price;

          totalCount += quantity;
          totalPrice += price;
        });

        if (
          varaintAccordion.querySelector(".selected-num") &&
          varaintAccordion.querySelector(".selected-price")
        ) {
          varaintAccordion.querySelector(".selected-num").dataset.count =
            totalCount;
          varaintAccordion.querySelector(".selected-price").dataset.price =
            totalPrice;
        }
      }

      updatePDPTotalPrice();
      updateQuickCheckoutBox();
    });

    // Handle subscription period change
    $(".product-recharge-block").on("click", function () {
      updatePDPTotalPrice();
    });

    const addToCartButton = document.querySelector(".btn-add-to-cart");

    if (addToCartButton) {
      addToCartButton.addEventListener("click", async function () {
        let isInputChecked = false;
        const quantityInputs = document.querySelectorAll(".variant-qty-input");

        for (let input of quantityInputs) {
          if (input.value > 0) {
            isInputChecked = true;
            break;
          }
        }

        if (isInputChecked) {
          this.classList.add("btn--loading");
          await addToCart();
          this.classList.remove("btn--loading");
        } else {
          console.log("No items selected to add to the cart.");
        }
      });
    }

    $(".js-tab-heading").click(function (e) {
      e.preventDefault();

      const $this = $(this);
      const target = $this.data("target");

      if ($this.hasClass("w--current")) {
        $this.removeClass("w--current");
        $(`.pdp-main_tab-details[data-target="${target}"]`).removeClass(
          "w--tab-active active"
        );
      } else {
        $(".js-tab-heading").removeClass("w--current");
        $(".pdp-main_tab-details").removeClass("w--tab-active active");
        $this.addClass("w--current");
        $(`.pdp-main_tab-details[data-target="${target}"]`).addClass(
          "w--tab-active active"
        );
      }
    });

    // Handle product item accordion event in Quick Checkout
    $(".quick-checkout-product-item").on("click", function () {
      if (!$(this).hasClass("active")) {
        $(".quick-checkout-product-item.active").next().slideToggle();
        $(".quick-checkout-product-item.active").toggleClass("active");
      }
      $(this).toggleClass("active");
      $(this).next().slideToggle();
    });

    // Update items list in Quick Checkout
    function updateQuickCheckoutBox() {
      if (!document.querySelector(".quick-checkout_order-summary")) return;
      let quickCheckoutContent = document.querySelector(
        ".js-quick-checkout-content"
      );
      let totalPrice = 0;
      let quickCheckoutContentHtml = "";

      const quantityInputs = document.querySelectorAll(".variant-qty-input");

      quickCheckoutContent.innerHTML = "";
      document
        .querySelector(".quick-checkout-empty-message")
        .classList.remove("hidden");

      quantityInputs.forEach((input) => {
        if (input.value > 0) {
          document
            .querySelector(".quick-checkout-empty-message")
            .classList.add("hidden");

          if (input.dataset.planId && input.dataset.planId !== "null") {
            totalPrice += getDiscountedTotalPrice(input);
            const item = drawQuickCheckoutItem(
              input,
              getDiscountedTotalPrice(input)
            );
            quickCheckoutContentHtml += item;
          } else {
            totalPrice += getOriginTotalPrice(input);
            const item = drawQuickCheckoutItem(
              input,
              getOriginTotalPrice(input)
            );
            quickCheckoutContentHtml += item;
          }
        }
      });

      quickCheckoutContent.innerHTML = quickCheckoutContentHtml;

      if (document.querySelector(".js-quick-checkout-total")) {
        document.querySelector(".js-quick-checkout-total").textContent =
          formatMoney(totalPrice, window.Shopify.money_format);
      }
    }

    function updateQuickCheckoutTotalPrice() {
      const quantityInputs = document.querySelectorAll(".variant-qty-input");
      let totalPrice = 0;

      quantityInputs.forEach((input) => {
        if (input.value > 0) {
          if (input.dataset.planId && input.dataset.planId !== "null") {
            totalPrice += getDiscountedTotalPrice(input);
          } else {
            totalPrice += getOriginTotalPrice(input);
          }
        }
      });

      if (document.querySelector(".js-quick-checkout-total")) {
        document.querySelector(".js-quick-checkout-total").textContent =
          formatMoney(totalPrice, window.Shopify.money_format);
      }
    }

    // Handle "Checkout" button click event, navigate to checkout page
    $(".btn-quick-checkout").on("click", (e) => {
      e.preventDefault();
      let inputs = document
        .querySelector(".section-quick-checkout")
        .querySelectorAll(".variant-qty-input");
      let data = [];

      for (let i = 0; i < inputs.length; i++) {
        const element = inputs[i];

        if (element.value > 0) {
          let obj = {
            id: element.dataset.id,
            quantity: element.value,
            selling_plan: element.dataset.planId ?? null,
          };
          data.push(obj);
        }
      }

      // Add selected products to cart
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: data,
        }),
      }).then((response) => {
        if (response.ok) {
          location.href = "/checkout";
        }
      });
    });

    const radioButtons = document.querySelectorAll(
      'input[type="radio"][name^="selling-option-"]'
    );

    // Update recharge block selection
    function updateRechargeBlockSelection() {
      radioButtons.forEach((radio) => {
        const block = radio.closest(".product-recharge-block");
        if (radio.checked) {
          block.classList.add("selected");
        } else {
          block.classList.remove("selected");
        }
      });
    }

    // Handle recharge type change
    radioButtons.forEach((radio) => {
      radio.addEventListener("change", updateRechargeBlockSelection);
    });

    function handleSubscribeCheckboxChange(event) {
      const itemId = event.target.getAttribute("data-item-id");
      const quantityInputs = document.querySelectorAll(".variant-qty-input");

      let selectedInput;

      quantityInputs.forEach((input) => {
        if (input.dataset.id === itemId) {
          selectedInput = input;
        }
      });

      const block = event.target.closest(".cart-item__subscription");
      const selectedSubscriptionDiscountSpan = document.getElementById(
        `quick-checkout-subscription-${selectedInput.dataset.id}-discount`
      );

      const itemPriceElement = document.getElementById(
        `quick-checkout-price-${selectedInput.dataset.id}`
      );
      selectedSubscriptionDiscountSpan.innerText =
        STATIC_SUBSCRIPTION_PLAN_GROUP[0].discount;

      // Handle subscription plan ID assignment
      if (block.classList.contains("selected")) {
        block.classList.remove("selected");
        selectedInput.setAttribute("data-plan-id", null);

        itemPriceElement.innerText = formatMoney(
          getOriginTotalPrice(selectedInput),
          window.Shopify.money_format
        );
      } else {
        block.classList.add("selected");
        selectedInput.setAttribute(
          "data-plan-id",
          STATIC_SUBSCRIPTION_PLAN_GROUP[0].id
        );

        itemPriceElement.innerText = formatMoney(
          getDiscountedTotalPrice(selectedInput),
          window.Shopify.money_format
        );
      }

      updateQuickCheckoutTotalPrice();

      const selectOptionContainer = document.querySelector(
        `.cart-item__subscription-period-select[data-item-id="${itemId}"]`
      );
      const subscriptionPeriodOptions =
        selectOptionContainer.querySelectorAll("button");

      // Activate the first subscription period option
      subscriptionPeriodOptions.forEach((option) => {
        option.classList.remove("active");
      });
      subscriptionPeriodOptions[0].classList.add("active");
    }

    // Handle subscription period selection in Quick Checkout
    function updateSubscribeFrequencySelection(event) {
      const itemId = event.target.getAttribute("data-item-id");
      const planId = event.target.getAttribute("data-plan-id");
      const discountValue = event.target.getAttribute("data-discount");
      const quantityInputs = document.querySelectorAll(".variant-qty-input");
      const selectOptionContainer = document.querySelector(
        `.cart-item__subscription-period-select[data-item-id="${itemId}"]`
      );
      const subscriptionPeriodOptions =
        selectOptionContainer.querySelectorAll("button");
      const itemPriceElement = document.getElementById(
        `quick-checkout-price-${itemId}`
      );

      // Activate the selected subscription period option
      subscriptionPeriodOptions.forEach((option) => {
        option.classList.remove("active");
      });
      event.target.classList.add("active");

      document.getElementById(
        `quick-checkout-subscription-${itemId}-discount`
      ).innerText = discountValue;

      // Assign the selected plan id to the quantity input
      quantityInputs.forEach((input) => {
        if (input.dataset.id === itemId) {
          input.setAttribute("data-plan-id", planId);

          itemPriceElement.innerText = formatMoney(
            getDiscountedTotalPrice(input),
            window.Shopify.money_format
          );
        }
      });

      updateQuickCheckoutTotalPrice();
    }

    window.addEventListener("change", (event) => {
      // Handle subscription checkbox change
      if (event.target.type === "checkbox") {
        handleSubscribeCheckboxChange(event);
      }
    });

    window.addEventListener("click", (event) => {
      // Handle subscription period selection
      if (
        event.target.classList.contains("cart-item__subscription-period-item")
      ) {
        updateSubscribeFrequencySelection(event);
      }

      // Handle remove product on Quick Checkout
      if (event.target.classList.contains("js-remove-quick-product")) {
        document.querySelector(
          `.variant-qty-input[data-id="${event.target.dataset.target}"]`
        ).value = 0;

        updatePDPTotalPrice();
        updateQuickCheckoutBox();
      }
    });

    // Initial product recharge block selection on PDP
    updateRechargeBlockSelection();

    //poduct upsell
    const upsellSlider = document.querySelector(".product-upsell");

    if (upsellSlider) {
      const swiper = new Swiper(upsellSlider, {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        pagination: {
          el: ".product-upsell__pagination",
          clickable: true,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
      });
    }

    //add to cart
    const upsellButtons = document.querySelectorAll(
      ".product-upsell__add-to-cart"
    );

    upsellButtons.forEach((upsellButton) => {
      upsellButton.addEventListener("click", async function () {
        this.classList.add("btn--loading");
        const productTitle = this.dataset.productName;
        let data = [
          {
            id: this.dataset.id,
            quantity: 1,
          },
        ];

        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              items: data,
            }),
          });

          if (response.ok) {
            try {
              const cartResponse = await fetch(
                window.Shopify.routes.root + "cart.js",
                {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json",
                  },
                }
              );

              if (cartResponse.ok) {
                const cartData = await cartResponse.json();
                const itemCount = cartData.item_count;
                document.querySelector(".header-cart_item-count").textContent =
                  itemCount;
              }
            } catch (cartError) {
              console.error("Cart Fetch Error:", cartError);
            }

            document.querySelector(
              ".added-notification_product-title"
            ).innerHTML = productTitle;
            document
              .querySelector(".added-notification")
              .classList.add("active");
            setTimeout(() => {
              document
                .querySelector(".added-notification")
                .classList.remove("active");
            }, 6000);
          } else {
            console.error("Response not OK. Status Code:", response.status);
          }
        } catch (error) {
          console.error("Fetch Error:", error);
        } finally {
          this.classList.remove("btn--loading");
        }
      });
    });

    //sticky add to cart

    function toggleProductPriceWrap() {
      const element = document.querySelector(".product-price-wrap");
      const stickyProductForm = document.querySelector(".sticky-product-form");
      const originalParent = document.querySelector(".product-info-wrap");

      if (!element || !stickyProductForm || !originalParent) return;

      if (window.innerWidth <= 640) {
        if (!stickyProductForm.contains(element)) {
          stickyProductForm.appendChild(element);
        }
      } else {
        const allChildren = Array.from(originalParent.children);
        if (allChildren.indexOf(element) !== 4) {
          originalParent.insertBefore(element, allChildren[4] || null);
        }
      }
    }

    window.addEventListener("load", toggleProductPriceWrap);
    window.addEventListener("resize", toggleProductPriceWrap);

    const stickyAddToCartButton = document.querySelector(
      ".sticky-product-form .btn-add-to-cart"
    );

    if (stickyAddToCartButton) {
      stickyAddToCartButton.addEventListener("click", async function () {
        let isInputChecked = false;
        const quantityInputs = document.querySelectorAll(".variant-qty-input");

        for (let input of quantityInputs) {
          if (input.value > 0) {
            isInputChecked = true;
            break;
          }
        }

        if (isInputChecked) {
          this.classList.add("btn--loading");
          await addToCart();
          this.classList.remove("btn--loading");
        } else {
          console.log("No items selected to add to the cart.");
        }
      });
    }
  });
})();

document.addEventListener("DOMContentLoaded", function () {
  const gallerySlider = document.querySelector(".cm-product-gallery__main");
  const thumbnailsSlider = document.querySelector(".cm-product-thumbnails");

  let swiperThumbnails;
  let swiperGallery;

  function initSwipers() {
    if (!thumbnailsSlider || !gallerySlider) {
      return;
    }

    swiperThumbnails = new Swiper(thumbnailsSlider, {
      direction: window.innerWidth > 576 ? "vertical" : "horizontal",
      slidesPerView: 4,
      spaceBetween: 8,
      navigation: {
        nextEl: ".product-thumbnails__next",
        prevEl: ".product-thumbnails__prev",
      },
      on: {
        init: function () {
          this.slides.forEach((slide) => {
            slide.addEventListener("click", () => {
              this.slideNext();
            });
          });
        },
      },
    });

    swiperGallery = new Swiper(gallerySlider, {
      slidesPerView: 1,
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      thumbs: {
        swiper: swiperThumbnails,
      },
    });
  }

  function updateGallery(color) {
    const selectedVariant = document.querySelector(
      `.variant-images[data-color="${color}"]`
    );
    if (selectedVariant) {
      const imagePaths = selectedVariant
        .getAttribute("data-images")
        .split("|")
        .filter(Boolean);

      gallerySlider.querySelector(".swiper-wrapper").innerHTML = "";
      thumbnailsSlider.querySelector(".swiper-wrapper").innerHTML = "";

      imagePaths.forEach((src) => {
        const slide = document.createElement("div");
        slide.classList.add("swiper-slide");
        slide.innerHTML = `<img src="${src}" data-fancybox="${color}" alt="${color}" width="667" height="667">`;
        gallerySlider.querySelector(".swiper-wrapper").appendChild(slide);

        const thumbSlide = document.createElement("div");
        thumbSlide.classList.add("swiper-slide");
        thumbSlide.innerHTML = `<img src="${src}" alt="${color}" width="80" height="72">`;
        thumbnailsSlider
          .querySelector(".swiper-wrapper")
          .appendChild(thumbSlide);
      });

      if (swiperThumbnails) swiperThumbnails.destroy(true, true);
      if (swiperGallery) swiperGallery.destroy(true, true);

      initSwipers();
    }
  }

  document.querySelectorAll(".prodct-variant__title").forEach((title) => {
    title.addEventListener("click", function () {
      const color = this.dataset.color;
      updateGallery(color);
    });
  });

  initSwipers();

  //sticky pdp form
  const stickyForm = document.querySelector(".sticky-product-form");
  const pdpLayout = document.querySelector(".pdp-main_layout");

  const isInViewport = (element) => {
    const rect = element.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  };

  const isMobile = window.matchMedia("(max-width: 640px)");

  const onScroll = () => {
    if (isMobile.matches) {
      if (isInViewport(pdpLayout)) {
        stickyForm.classList.remove("hidden-form");
      } else {
        stickyForm.classList.add("hidden-form");
      }
    } else {
      stickyForm.classList.add("hidden-form");
    }
  };

  isMobile.addEventListener("change", () => {
    onScroll();
  });

  window.addEventListener("scroll", onScroll);

  onScroll();

  //mobile fancybox

  document
    .querySelectorAll(".prodct-variant__title[data-fancybox-trigger]")
    .forEach((button) => {
      button.addEventListener("click", function () {
        let galleryGroup = this.getAttribute("data-fancybox-trigger");
        let galleryItems = document.querySelectorAll(
          `img[data-fancybox='${galleryGroup}']`
        );

        if (window.innerWidth <= 576) {
          if (galleryItems.length > 0) {
            Fancybox.bind(`[data-fancybox="${galleryGroup}"]`, {
              Thumbs: {
                type: "classic",
              },
            });
          }
        } else {
          if (galleryItems.length > 0) {
            Fancybox.destroy();
          }
        }
      });
    });

  //product popups
  document.querySelectorAll("[data-popup]").forEach((button) => {
    button.addEventListener("click", function () {
      const popupId = this.getAttribute("data-popup");
      const popup = document.getElementById(popupId);
      if (popup) {
        popup.classList.add("show");
        document.body.classList.add("overflow-hidden");
      }
    });
  });

  document.querySelectorAll(".pdp-popup .close").forEach((closeButton) => {
    closeButton.addEventListener("click", function () {
      this.closest(".pdp-popup").classList.remove("show");
      document.body.classList.remove("overflow-hidden");
    });
  });

  window.addEventListener("click", function (event) {
    document.querySelectorAll(".pdp-popup").forEach((popup) => {
      const content = popup.querySelector(".pdp-popup__content");
      const image = content.querySelector("img");

      if (event.target === popup || event.target === content) {
        popup.classList.remove("show");
        document.body.classList.remove("overflow-hidden");
      }
    });
  });

  document.querySelectorAll(".pdp-popup__content img").forEach((img) => {
    img.addEventListener("click", function (event) {
      event.stopPropagation();
    });
  });
});
